module.exports = __webpack_public_path__ + "static/media/interMobile_3.4934f75d.jpg";